/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Cc_Position_Top_LeftInputs */



/**
* | output |
* | --- |
* | "Position Top Left" |
*
* @param {Shortcut_Keys_Name_Cc_Position_Top_LeftInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_cc_position_top_left = /** @type {((inputs?: Shortcut_Keys_Name_Cc_Position_Top_LeftInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Cc_Position_Top_LeftInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Positionner en haut a gauche")
	if (locale === "de") return /** @type {LocalizedString} */ ("Position oben links")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posizione in alto a sinistra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позиция в верхнем левом углу")
	if (locale === "es") return /** @type {LocalizedString} */ ("Posición superior izquierda")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("位置左上")
	if (locale === "ja") return /** @type {LocalizedString} */ ("左上に配置する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऊपरी बाएँ कोने में स्थित")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Posição: Superior Esquerda")
	return /** @type {LocalizedString} */ ("Position Top Left")
});